import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { VideoResponseWithProgress } from '@/types/cms';
import { getCurrentInstance } from 'vue';
import { RouteName, routeTo } from '@/router/routes';
import { VideoFormatter } from '@/helpers/video-formatter';
import TG4Image from '@/components/TG4Image.vue';
import TG4PlayIcon from '../TG4PlayIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EpisodeCell',
  props: {
    video: null,
    dynamicWidth: { type: Boolean },
    textColor: null
  },
  setup(__props: any) {

const props = __props as {
  video: VideoResponseWithProgress;
  dynamicWidth?: boolean;
  textColor?: string;
};


const instance = getCurrentInstance();
const router = instance?.proxy?.$router;




const title = computed(() => props.video.seriesTitle);
const subtitle = computed(() => VideoFormatter.getEpisodeCellSubtitle(props.video));

const progressPercent = computed(() => {
  const raw = props.video.playbackProgress;
  if (raw === null || raw === undefined) return null;

  const percent = raw <= 1 ? raw * 100 : raw;
  //Min of 1 so we show a little nubbin
  return Math.min(100, Math.max(1, percent));
});

const navigateToEpisode = () => {
  const navigation = router?.push(routeTo(RouteName.Episode, { videoId: props.video.vid }));
  //Swallow duplicate navigation errors
  navigation?.catch((err) => {
    if (err?.name === 'NavigationDuplicated') return;
    console.log(err);
  });
};

const textStyle = computed(() => {
  if (props.textColor) {
    return {
      color: props.textColor,
    };
  }
  return {};
});

return { __sfc: true,instance, router, props, title, subtitle, progressPercent, navigateToEpisode, textStyle, TG4Image, TG4PlayIcon }
}

})